import { ReactNode } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from 'styles';
import { useTab } from './context';

export interface TabContentProps {
  className?: string;
  value: string;
  children: ReactNode | ((props: { changeTab?: (tab: string) => void }) => JSX.Element);
}

export function TabsContent({ className, children, ...props }: TabContentProps) {
  const { onTabChange, fullWidth } = useTab();

  return (
    <TabsPrimitive.Content
      tabIndex={-1}
      className={cn(
        {
          'w-full': fullWidth,
        },
        className,
      )}
      {...props}
    >
      {typeof children === 'function' ? children({ changeTab: onTabChange }) : children}
    </TabsPrimitive.Content>
  );
}
